<template>
<div>
  <v-data-table :headers="headers" :search="search" :items="desserts" sort-by="id" class="elevation-1" :footer-props="{'items-per-page-options':[50, 100, -1]}" hide-default-footer>
    <template v-slot:top>
      <v-toolbar flat>
        <v-row>
          <v-col>
            <v-toolbar-title>Ventes</v-toolbar-title>
          </v-col>
          <v-col>
            <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="date1" label="Date 1" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="date2" label="Date 2" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-btn small @click="filterVents()">FILTER</v-btn>
          </v-col>
          <!-- <v-col>
            <v-combobox v-model="selectMode" :items="itemsMode" item-text="mode" item-value="id" label="Mode"></v-combobox>
          </v-col>
          <v-col>
            <v-text-field append-icon="mdi-magnify" label="Rechercher" single-line hide-details @keyup="onKeySearch($event)" ></v-text-field>
          </v-col> -->
        </v-row>
        <v-spacer></v-spacer>
        <!-- <v-dialog v-model="dialog" max-width="500px"> -->
        <v-dialog v-model="dialog" max-width="1000px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">Nouvelle Vente</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-combobox v-model="selectGuide" :items="itemsGuides" item-text="guide" item-value="id" label="Guide" v-on:change="changeGuide(selectGuide)"></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <!-- <v-text-field v-model="editedItem.passage" label="Passage"></v-text-field> -->
                    <v-combobox v-model="editedItem.passage" :items="itemsPassages" item-text="name" item-value="name" label="Passage"></v-combobox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="4" md="4">
                    <!-- <v-text-field v-model="editedItem.accompagnateur" label="Accompagnateur"></v-text-field> -->
                    <v-combobox v-model="selectAccompagnateur" :items="itemsGuides" item-text="guide" item-value="id" label="Accompagnateur" v-on:change="changeAccompagnateur(selectAccompagnateur)"></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-combobox v-model="selectAgency" :items="itemsAgencys" item-text="agency" item-value="id" label="Agence" v-on:change="changeAgency(selectAgency)"></v-combobox>
                    <!-- <v-text-field v-model="editedItem.agence" label="Agence"></v-text-field> -->
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.date_vente" label="date" type="date"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.vente" label="Montant vente" type="number" @keyup="calculCommission()"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="editedItem.commission"
                      label="% commission"
                      type="number"
                      @keyup="calculCommission()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="editedItem.reglement_guide"
                      label="Montant commission Guide"
                      type="number"
                      id="mntcommision"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- show if select agence -->
                <v-row>
                  <v-col
                    cols="12"
                    sm="4"
                    md="4"
                    v-if="showPaymentAccompagnateur == true"
                  >
                    <v-text-field
                      v-model="editedItem.reglement_accompagnateur"
                      label="Montant Accompagnateur"
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                    md="4"
                    v-if="showPaymentAgency == true"
                  >
                    <v-text-field
                      v-model="editedItem.commission_agency"
                      label="% Commission Agence"
                      type="number"
                      @keyup="calculCommissionAgency()"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                    md="4"
                    v-if="showPaymentAgency == true"
                  >
                    <v-text-field
                      v-model="editedItem.reglement_agency"
                      label="Reglement Agence"
                      type="number"
                      id="mntcommisionAgence"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="close">annuler</v-btn>
              <v-btn color="green" text @click="save">Valider</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDetails" max-width="100%">
          <v-card>
            <v-card-title>plus details</v-card-title>
            <!-- <v-card-text> -->
            <v-data-table
              :headers="headerDetails"
              :items="dessertDetails"
              sort-by="created_at"
              class="elevation-2"
            ></v-data-table>
            <!-- </v-card-text> -->
            <br /><br />
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline"
              >Êtes-vous sûr de supprimer ?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="green" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialogconfirm" max-width="800px">
          <v-card>
            <v-card-title class="headline">Are you sure you delivered this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="closeDeliverede">Cancel</v-btn>
              <v-btn color="green" text @click="DeliveredItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </v-toolbar>
      <v-row>
        <v-col>
          <v-combobox v-model="selectMode" :items="itemsMode" item-text="mode" item-value="id" label="Mode"></v-combobox>
        </v-col>
        <v-col>
          <v-text-field append-icon="mdi-magnify" label="Rechercher" single-line hide-details @keyup="onKeySearch($event)" ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <!-- <template v-slot:[`item.accompagnateur.guide`]="{ item }">
      <span v-if="accompagnateur.guide == null">test</span>
      <span v-if="accompagnateur.guide != null">{{ item.accompagnateur.guide }}</span>
    </template> -->

    <template v-slot:[`item.actions`]="{ item }">
      <!-- <v-icon class="mr-2" color="blue" @click="showItem(item)">mdi-message-text</v-icon> -->
      <v-icon
        small
        color="blue"
        class="mr-2"
        v-if="item.reglement_agency != null"
        @click="showItem(item)"
        >mdi-message-text</v-icon
      >
      <v-icon small color="blue" class="mr-2" @click="editItem(item)"
        >mdi-pencil</v-icon
      >
      <v-icon class="mr-2" color="red" @click="deleteItem(item)"
        >mdi-delete</v-icon
      >
      <!-- <v-icon class="mr-2" color="green" @click="confirmItem(item)">mdi-cloud-download-outline</v-icon> -->
    </template>
  </v-data-table>
   <div class="mtb" style=" width: 100%; border-top:1px solid #97979754">
      <v-row>
        <v-col cols="12" sm="2" md="2">
          <span style="margin-left:10px;">
            {{ optionPages.from }} - {{ optionPages.to }} of {{ optionPages.total }}
          </span>
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-icon small class="mr-2" style="margin-right:25px !important; font-size:22px !important;" @click="nextSales(optionPages.first_page_url)" :disabled="optionPages.prev_page_url ? disabled : ''">mdi-skip-backward-outline</v-icon>
          <v-icon small class="mr-2" style="margin-right:25px !important; font-size:22px !important;" @click="nextSales(optionPages.prev_page_url)" :disabled="optionPages.prev_page_url ? disabled : ''">mdi-page-first</v-icon>
          <v-icon small class="mr-2" style="margin-right:25px !important; font-size:22px !important;" @click="nextSales(optionPages.next_page_url)" :disabled="optionPages.next_page_url ? disabled : ''">mdi-page-last</v-icon>
          <v-icon small class="mr-2" style="margin-right:25px !important; font-size:22px !important;" @click="nextSales(optionPages.last_page_url)" :disabled="optionPages.next_page_url ? disabled : ''">mdi-skip-forward-outline</v-icon>
        </v-col>
        <v-col cols="12" sm="4" md="4">
        </v-col>
        <v-col cols="12" sm="2" md="2">
        </v-col>
        <v-col cols="12" sm="2" md="2">
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style scoped>
table.v-table tbody tr td {
  font-size: 40px !important;
}
.title {
  font-weight: bold;
  text-align: center;
}
.v-data-footer
{
  display: none !important;
  visibility: hidden !important;
}
.mtb {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  background-color: white;
}
.mtbtn {
  border: none !important;
  background-color: transparent;
}
</style>

<script>
import axios from "axios";
export default {
  data() {
    return {
      search: "",
      menu1: false,
      menu2: false,
      date1: "",
      date2: "",
      dialog: false,
      dialogDelete: false,
      dialogDetails: false,
      showPaymentAgency: false,
      showPaymentAccompagnateur: false,
      itemsGuides: [],
      itemsPassages: ["Groupe", "Particulier"],
      itemsAgencys: [],
      selectMode:{
        mode: "Guide",
        id: 1
      },
      itemsMode:[
        {
          mode: "Guide",
          id: 1
        },
        // {
        //   mode: "Accompagnateur",
        //   id: 2,
        // },
        // {
        //   mode: "Agence",
        //   id: 3,
        // },
      ],

      selectGuide: {
        guide: "",
        id: "",
      },
      selectAccompagnateur: {
        guide: "",
        id: "",
      },
      selectAgency: {
        agency: "",
        id: "",
      },
      localhost: "https://guide.artnaji.com/index.php/api",
      // localhost:'http://localhost:8000/api',
      headerDetails: [
        { text: "Règlement Accompagnateur", value: "reglement_accompagnateur" },
        { text: "Commission Agence", value: "commission_agency" },
        { text: "Règlement Agence", value: "reglement_agency" },
      ],
      headers: [
        { text: "Guide", value: "guide.guide" },
        { text: "Passage", value: "passage" },
        { text: "Accompagnateur", value: "accompagnateur" },
        { text: "Agence", value: "agence" },
        { text: "Vente", value: "vente" },
        { text: "Commission %", value: "commission" },
        { text: "Règlement guide", value: "reglement_guide" },
        { text: "Bénéfice", value: "benefice" },
        { text: "Date", value: "date_vente" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dessertDetails: [],
      desserts: [],
      optionPages: {},
      editedIndex: -1,
      editedItemid: 0,
      nextSalesPrimary : true,
      valueSearch : '',
      editedItem: {
        product: "",
        reglement_guide: "0",
        reglement_agency: "0",
        quantity: 0,
      },
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nouvelle Vente" : "Modifier Vente";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    if (!localStorage.getItem("user-token")) {
      window.location.href = "../App";
    }
    this.initialize();
  },

  methods: {
    initialize() {
      this.nextSalesPrimary = true
      this.desserts = [];
      axios
        .get(
          this.localhost + "/guides"
          // ,{
          //   headers:{
          //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
          //   }
          // }
        )
        .then((response) => {
          this.itemsGuides = response.data;
        });
      axios
        .get(
          this.localhost + "/agency"
          // ,{
          //   headers:{
          //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
          //   }
          // }
        )
        .then((response) => {
          this.itemsAgencys = response.data;
        });
      axios
        .get(
          this.localhost + "/sales"
          // ,{
          //   headers:{
          //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
          //   }
          // }
        )
        .then((response) => {
          this.desserts = response.data.data;
          this.optionPages = response.data;
          // console.log(response.data)
          // this.nextSales(this.optionPages.next_page_url);
          // alert(this.optionPages.next_page_url)
        });
    },

    nextSales(url) {
      // alert('hello')
      if(this.nextSalesPrimary == true){
        axios.get(url
            // ,{
            //   headers:{
            //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
            //   }
            // }
        ).then((response) => {
            this.desserts = response.data.data;
            this.optionPages = response.data;
            //   response.data.data.forEach(element => {
            //     this.desserts.push(element);
            //   });
            // this.optionPages = response.data;
            // this.nextSales(this.optionPages.next_page_url);
        });
      }else{
        axios.post(url
          ,{ name: this.valueSearch, type: this.selectMode.id }
          // ,{
          //   headers:{
          //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
          //   }
          // }
        )
        .then((response) => {
          this.desserts = response.data.data;
          this.optionPages = response.data;
        });
      }
    },

    // Checkout(){
    //   axios.post(this.localhost+'/orders/checkout',{date1:this.date1,date2:this.date2},{responseType: 'blob'})
    //   .then(response => {
    //     const url = window.URL.createObjectURL(new Blob([response.data]));
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', "Caisse.pdf");
    //     document.body.appendChild(link);
    //     link.click();
    //     this.dialogRecu=false
    //   })
    // .catch(ex => {console.error(ex);});
    // },

    onKeySearch(event) {
      clearTimeout(this.timeout);
      var $this = this;
      this.timeout = setTimeout(function () {
        if (event.keyCode != 13) {
          $this.executeListing(event.target.value);
        }
      }, 1000);
    },

    executeListing(value) {
      if(value == ""){
        this.nextSalesPrimary = true
         axios
        .get(
          this.localhost + "/sales"
          // ,{
          //   headers:{
          //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
          //   }
          // }
        )
        .then((response) => {
          this.desserts = response.data.data;
          this.optionPages = response.data;
          // console.log(response.data)
          // this.nextSales(this.optionPages.next_page_url);
          // alert(this.optionPages.next_page_url)
        });
      }else{
        this.nextSalesPrimary =false
        this.valueSearch =value 
        axios
          .post(
            this.localhost + "/sales/search",
            { name: value, type: this.selectMode.id }
            // ,{
            //   headers:{
            //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
            //   }
            // }
          )
          .then((response) => {
            this.desserts = response.data.data;
            this.optionPages = response.data;
          });
      }
    },

    filterVents() {
      this.desserts = [];
      axios
        .post(
          this.localhost + "/sales/filter",
          { date1: this.date1, date2: this.date2 }
          // ,{
          //   headers:{
          //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
          //   }
          // }
        )
        .then((response) => {
          this.desserts = response.data.data;
          this.optionPages = response.data;
        });
    },

    changeAgency(item) {
      this.editedItem.agency_id = item.id;
      this.showPaymentAgency = true;
    },

    changeAccompagnateur(item) {
      this.showPaymentAccompagnateur = true;
      this.editedItem.accompagnateur_id = item.id;
    },

    changeGuide(item) {
      this.editedItem.guide_id = item.id;
    },

    showItem(item) {
      this.dessertDetails = [];
      this.dessertDetails.push(item);
      this.dialogDetails = true;
    },

    editItem(item) {
      this.editedIndex = 0;
      this.editedItem = item;
      this.itemsGuides.forEach((element) => {
        if (item.accompagnateur_id != null) {
          this.showPaymentAccompagnateur = true;
          if (element.id == item.accompagnateur_id) {
            this.selectAccompagnateur = element;
          }
        }
        if (element.id == item.guide_id) {
          this.selectGuide = element;
        }
      });
      if (item.agency_id != null) {
        this.itemsAgencys.forEach((elementAgency) => {
          if (elementAgency.id == item.agency_id) {
            this.selectAgency = elementAgency;
          }
        });
        this.showPaymentAgency = true;
      }
      this.dialog = true;
    },

    calculCommissionAgency() {
      if (
        this.editedItem.vente != "" &&
        this.editedItem.commission_agency != ""
      ) {
        document.getElementById("mntcommisionAgence").value = parseFloat(
          this.editedItem.vente * (this.editedItem.commission_agency / 100)
        );
        this.editedItem.reglement_agency = document.getElementById(
          "mntcommisionAgence"
        ).value;
      }
    },

    calculCommission() {
      // alert(this.editedItem.vente)
      // alert(this.editedItem.commission)
      // alert(this.editedItem.reglement_guide)
      if (this.editedItem.vente != "" && this.editedItem.commission != "") {
        document.getElementById("mntcommision").value = parseFloat(
          this.editedItem.vente * (this.editedItem.commission / 100)
        );
        this.editedItem.reglement_guide = document.getElementById(
          "mntcommision"
        ).value;
      }
    },

    save() {
      if (this.editedIndex > -1) {
        axios
          .put(
            this.localhost + "/sales/" + this.editedItem.id,
            this.editedItem
            //  ,{
            //   headers:{
            //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
            //   }
            // }
          )
          .then((resorderdelete) => {
            console.log(resorderdelete);
            this.editedItem = {};
            this.dialog = false;
            this.initialize();
          });
      } else {
        axios
          .post(
            this.localhost + "/sales",
            this.editedItem
            //  ,{
            //   headers:{
            //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
            //   }
            // }
          )
          .then((resorderdelete) => {
            console.log(resorderdelete);
            this.editedItem = {};
            this.dialog = false;
            this.initialize();
          });
      }
    },

    // delete
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItemid = Object.assign({}, item).id;
      this.dialogDelete = true;
    },

    // confirm delete
    deleteItemConfirm() {
      axios
        .delete(
          this.localhost + "/sales/" + this.editedItemid
          // ,{
          //   headers:{
          //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
          //   }
          // }
        )
        .then((resorderdelete) => {
          console.log(resorderdelete);
          this.initialize();
          this.closeDelete();
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
    },
  },
};
</script>
